import React, { FC } from 'react'
import { isArray } from 'lodash'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { LOGO_TEXT } from '../../../constants'
import { Events, MATCH_COMPOUND } from '../../../FSM/shared/constants'
import { FSMSwitch, FSMMatch } from '../../../FSM'

import { Typography, LDCardTwoCol, LMBgHeader, withHidden } from '@dg-shared'
import Loading from '../Loading/Page'
import useLogic from './useLogic'
import Fail from './Content/Fail'
import Mileage from './Content/Mileage'
import Done from './Content/Done'
import { logoMax, logoMin } from 'BrandedImages'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { getDataComponentName, getFlowName } from '@dg-util'
import { FlowName } from '../../../config'
import MyPagesQBDone from './Content/MyPagesQBDone'

const useStyles = makeStyles((theme) =>
  createStyles({
    description: {
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
  })
)

const MobileScreen = withHidden(LMBgHeader, true)
const DesktopScreen = withHidden(LDCardTwoCol, false)

const PurchasedPage: FC<CommonPageProps> = ({ ...props }) => {
  const classes = useStyles()
  const {
    service: { send },
    currentState,
  } = props

  const { loading, signOut, mileageSubmit, getText } = useLogic(send, currentState)
  const { title, subtitle, description } = getText()

  const descriptionText =
    isArray(description) &&
    description.map((el, idx) => (
      <Typography
        size='small'
        color='textMain'
        key={`description-${idx}`}
        className={classes.description}
      >
        {el}
      </Typography>
    ))

  const donePagePerFlowMapping = {
    [FlowName.MY_PAGES]: () => <MyPagesQBDone flowService={props.service} />,
    [FlowName.QUOTE_AND_BUY]: () => (
      <Done signOut={signOut} loading={loading} flowService={props.service} />
    ),
  }

  const flowName =
    // Handle case when MyPages flow switched to QB for new Quote purchase
    props.service.state?.context?.prevConfig?.flow === FlowName.MY_PAGES
      ? FlowName.MY_PAGES
      : getFlowName()

  const body = (
    <FSMSwitch>
      <FSMMatch is={MATCH_COMPOUND.PURCHASED_MILEAGE}>
        <Mileage handleSubmit={mileageSubmit} handleSkip={() => props.service.send(Events.DONE)} />
      </FSMMatch>
      <FSMMatch is={MATCH_COMPOUND.PURCHASED_DONE}>{donePagePerFlowMapping[flowName]()}</FSMMatch>
      <FSMMatch is={MATCH_COMPOUND.PURCHASED_FAIL}>
        <Fail
          handleBack={async () => {
            await signOut()
            props.service.send(Events.BACK)
          }}
        />
      </FSMMatch>
    </FSMSwitch>
  )

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <MobileScreen
        headerTitle={title}
        headerSubTitle={subtitle}
        textLogoAlt={LOGO_TEXT}
        brandPageBackground='secondaryMobile'
        imageLogo={logoMin}
      >
        {descriptionText}
        {body}
      </MobileScreen>
      <DesktopScreen
        textLogoAlt={title}
        imageLogo={logoMax}
        brandPageBackground='secondary'
        brandPageBackgroundCard='secondaryCard'
        isReverse
      >
        <div data-componentname={getDataComponentName(__filename)}>
          <Typography type='h1'>{title}</Typography>
          <Typography type='h3'>{subtitle}</Typography>
          {descriptionText}
        </div>
        {body}
      </DesktopScreen>
    </>
  )
}

export default PurchasedPage
